<template>
  <div class="container">
    <el-aside id="silderLeft" style="width: 350px;">
      <el-scrollbar style="height: 100%;" class="scrollbar-for" wrap-style="overflow-x:hidden;">
        <el-menu
          :default-openeds="['1', '2', '3', '4']"
          class="my-el-menu"
          default-active="1-1"
          :collapse="isCollapse"
        >
          <el-submenu index="1" background-color="#10d534">
            <template slot="title"
              ><i class="el-icon-wind-power"></i>待审核题目</template
            >

            <el-menu-item
              v-for="(item, index) in questionVerifyRequiredDetailList"
              @click.native="emitQuestionId(item.questionId)"
            >
              <span style="font-size: 16px"
                >{{ index + 1 }} .(题目ID：{{ item.questionId }}) {{ item.content }}</span
              >
            </el-menu-item>
          </el-submenu>

          <!-- <el-submenu index="2">
            <template slot="title"
              ><i class="el-icon-potato-strips"></i>审核通过题目</template
            >
  
            <el-menu-item v-for="(item, index) in questionVerifyPassedDetailList"
              >{{ index + 1 }} . {{ item.content }}</el-menu-item
            >
          </el-submenu> -->
          <el-submenu index="2">
            <template slot="title"
              ><i class="el-icon-cherry"></i>审核不通过题目</template
            >
            <el-menu-item
              v-for="(item, index) in questionVerifyFailedDetailList"
              @click.native="emitQuestionId(item.questionId)"
              >{{ index + 1 }} . {{ item.content }}</el-menu-item
            >
          </el-submenu>
        </el-menu>
      </el-scrollbar>

      <!-- <div class="moveBtn" v-move></div> -->
    </el-aside>
  </div>
</template>

<script>
export default {
  name: "Aside",
  props: [
    "storeId",
    "sectionId",
    "questionVerifyRequiredDetailList",
    "questionVerifyPassedDetailList",
    "questionVerifyFailedDetailList",
  ],
  data() {
    return {
      isCollapse: false,
    };
  },

  mounted() {},
  //暂时用watch解决一开始题目ID传不进来的问题
  // watch:{
  //   questionVerifyRequiredDetailList(){
  //     this.$emit("emitQuestionId", this.questionVerifyRequiredDetailList[0].questionId);
  //   }
  // },

  methods: {
    emitQuestionId(questionId) {
      this.$emit("emitQuestionId", questionId);
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  // width: 300px;

  display: flex;
  max-height: 75vh;
  box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px,
    rgba(17, 17, 26, 0.05) 0px 8px 32px;
  .silderRight {
    // height: 100%;

    flex: 1;
  }

  #silderLeft {
    
    width: 250px;
    height: 100%;
    background-color: #f5f5f5;
    position: relative;

    
    /* overflow-y: auto; */
    .my-el-menu {
      
      background-color: #eef6f7;
      // background-color: #eef6f7;
      // height: 100vh;
      margin-top: 0px;
      .el-submenu__title {
        display: flex;
        align-items: center;
        .span {
          white-space: normal;
          word-break: break-all;
          line-height: 20px;
          flex: 1;
          padding-right: 20px;
        }
      }

      .el-menu-item {
        margin: 8px;
        border-radius: 20px;
        display: flex;
        align-items: center;
        padding: 4px;
        padding-right: 20px !important;
        height: auto;
        white-space: pre-wrap;
        line-height: 40px;
        color: #000;
        border: 1px solid rgb(195, 195, 195);
        .span {
          white-space: normal;
          word-break: break-all;
          line-height: 20px;
          flex: 1;
        }
      }
    }
    // .moveBtn {
    //   height: 100%;
    //   width: 10px;
    //   /* opacity: 0; */
    //   position: absolute;
    //   right: 0px;
    //   top: 0;
    //   cursor: col-resize;
    //   background-color: yellow;
    // }
  }
}
</style>
